import { SafetyReport, SafetyBehavior, SafetySpeeding } from "../../../models";

const getBehaviors = (data: any): SafetyBehavior[] =>
  (data || []).map((b: any) => ({
    behaviorType: b.behavior_type,
    count: b.count,
    scoreImpact: b.score_impact,
  }));

const getSpeeding = (data: any): SafetySpeeding[] =>
  (data || []).map((s: any) => ({
    speedingType: s.speeding_type,
    durationSeconds: s.duration_seconds,
    scoreImpact: s.score_impact,
  }));

export const getSafetyReport = (r: any): SafetyReport => ({
  available: !!r.available,
  reason: r.reason || undefined,
  driverId: r.driver_id,
  punchCardId: r.punch_card_id,
  windowStart: r.window_start,
  windowEnd: r.window_end,
  windowEndBasis: r.window_end_basis,
  vehicleScore: r.vehicle_score ?? undefined,
  driveDistanceMiles: r.drive_distance_miles ?? undefined,
  driveTimeMinutes: r.drive_time_minutes ?? undefined,
  behaviors: getBehaviors(r.behaviors),
  speeding: getSpeeding(r.speeding),
  fetchedAt: r.fetched_at ?? undefined,
});
